// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step-success[data-v-89bd3d54]{text-align:center}.step-success .step-success__title[data-v-89bd3d54]{color:#00afa1}.step-success .step-success__image[data-v-89bd3d54]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.step-success .step-success__image[data-v-89bd3d54]  svg{width:32px;height:32px}", ""]);
// Exports
module.exports = exports;
